import { ResourceEnum } from "src/constants/constants.ts";
import type { ModuleOptions } from "src/system/module.types.ts";
import { createModuleRoutePaths } from "src/system/createModuleRoutePaths.ts";
import { AccountingPostingVacantPositionModuleList } from "src/admin/modules/vacant-position/components/AccountingPostingVacantPositionModuleList/AccountingPostingVacantPositionModuleList.tsx";

const paths = createModuleRoutePaths({
  resource: ResourceEnum.VacantPosition,
});
export const module: ModuleOptions = {
  resource: ResourceEnum.VacantPosition,
  smallIcon: <i className="icon-15-positions" />,
  bigIcon: <i className="icon-20-positions" />,
  routeObjects: [
    {
      path: paths.root,
      Component: AccountingPostingVacantPositionModuleList,
    },
  ],
  disableEdit: true,
  disableDelete: true,
  disableCreate: true,
};
